export interface ISystemTimeZone {
  code: string;
  name: string;
  gmtDisplay: string;
  ianaName: string;
  displayName: string;
}

const TIME_ZONES: ISystemTimeZone[] = [
  {
    code: 'NST',
    name: 'Newfoundland Standard Time',
    gmtDisplay: 'GMT-03:30',
    ianaName: 'America/St_Johns',
    displayName: 'Newfoundland Standard Time (NST)'
  },
  {
    code: 'AST',
    name: 'Atlantic Standard Time',
    gmtDisplay: 'GMT-04:00',
    ianaName: 'America/Halifax',
    displayName: 'Atlantic Standard Time (AST)'
  },
  {
    code: 'EST',
    name: 'Eastern Standard Time',
    gmtDisplay: 'GMT-05:00',
    ianaName: 'America/New_York',
    displayName: 'Eastern Standard Time (EST)'
  },
  {
    code: 'CST',
    name: 'Central Standard Time',
    gmtDisplay: 'GMT-06:00',
    ianaName: 'America/Chicago',
    displayName: 'Central Standard Time (CST)'
  },
  {
    code: 'MST',
    name: 'Mountain Standard Time',
    gmtDisplay: 'GMT-07:00',
    ianaName: 'America/Denver',
    displayName: 'Mountain Standard Time (MST)'
  },
  {
    code: 'PST',
    name: 'Pacific Standard Time',
    gmtDisplay: 'GMT-08:00',
    ianaName: 'America/Los_Angeles',
    displayName: 'Pacific Standard Time (PST)'
  },
  {
    code: 'AKST',
    name: 'Alaska Standard Time',
    gmtDisplay: 'GMT-09:00',
    ianaName: 'America/Anchorage',
    displayName: 'Alaska Standard Time (AKST)'
  },
  {
    code: 'HST',
    name: 'Hawaii Standard Time',
    gmtDisplay: 'GMT-10:00',
    ianaName: 'Pacific/Honolulu',
    displayName: 'Hawaii Standard Time (HST)'
  },
];

const getUITimezones = () => {
  return TIME_ZONES;
};

export const dateTimeUtils = {
  getUITimezones,
};
